/* ============================================
   Babyworks — Homepage JS v9
   ============================================ */
(function () {
  'use strict';

  /* ── 3D STUDIO VIDEO — loop Arya, resume on tab return ── */
  var vid = document.getElementById('bw-studio-vid');
  if (vid) {
    vid.play().catch(function(){});
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') vid.play().catch(function(){});
    });
    window.addEventListener('focus', function () { vid.play().catch(function(){}); });
    document.addEventListener('touchstart', function h() {
      if (vid.paused) vid.play().catch(function(){});
      document.removeEventListener('touchstart', h);
    }, { once: true });
  }

  /* ── PRODUCT CAROUSEL ── */
  var grid = document.querySelector('.bw-pgrid');
  if (grid) {
    var origCards = Array.from(grid.querySelectorAll('.bw-pc'));
    var n = origCards.length;
    var isDesktop = window.innerWidth >= 768;

    if (n > 1 && !isDesktop) {
      /* ── MOBILE: infinite loop via clones ── */
      origCards.forEach(function(c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        grid.appendChild(clone);
      });
      origCards.slice().reverse().forEach(function(c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        grid.insertBefore(clone, grid.firstChild);
      });

      function centerCarousel() {
        var allCardsAll = grid.querySelectorAll('.bw-pc');
        var midIdx = n + Math.floor(n / 2);
        var card = allCardsAll[midIdx];
        if (!card) return;
        var gridRect = grid.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        if (cardRect.width === 0) return;
        grid.scrollLeft = grid.scrollLeft + cardRect.left - gridRect.left - (gridRect.width / 2) + (cardRect.width / 2);
      }

      grid.addEventListener('scroll', function() {
        var allCards = grid.querySelectorAll('.bw-pc');
        var setWidth = (allCards[0].offsetWidth + 8) * n;
        if (!setWidth) return;
        if (grid.scrollLeft < setWidth * 0.1) grid.scrollLeft += setWidth;
        if (grid.scrollLeft > setWidth * 2.1) grid.scrollLeft -= setWidth;
      });

      document.addEventListener('DOMContentLoaded', centerCarousel);
      setTimeout(centerCarousel, 50);
      setTimeout(centerCarousel, 300);
      setTimeout(centerCarousel, 600);
      window.addEventListener('load', function() { setTimeout(centerCarousel, 200); });
    }

    if (isDesktop) {
      /* ── DESKTOP: click-and-drag scrolling ── */
      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var dragged = false;

      grid.style.cursor = 'grab';

      grid.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        grid.classList.add('bw-dragging');
        grid.style.cursor = 'grabbing';
        startX = e.pageX;
        startScroll = grid.scrollLeft;
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        grid.classList.remove('bw-dragging');
        grid.style.cursor = 'grab';
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 4) dragged = true;
        grid.scrollLeft = startScroll - dx;
      });

      // Prevent link/add-to-cart clicks from firing right after a drag
      grid.addEventListener('click', function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      /* ── DESKTOP: mouse wheel → horizontal scroll ── */
      grid.addEventListener('wheel', function (e) {
        // If the gesture is already mostly horizontal (trackpad), let it pass through
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
        if (e.deltaY === 0) return;
        e.preventDefault();
        grid.scrollLeft += e.deltaY;
      }, { passive: false });
    }
  }

  /* ── GENDER ACCORDION ── */
  window.bwToggleGender = function(gender) {
    var cap   = gender === 'girls' ? 'Girls' : 'Boys';
    var body  = document.getElementById('bw' + cap + 'Body');
    var tab   = document.getElementById('bw' + cap + 'Tab');
    var arr   = document.getElementById('bw' + cap + 'Arr');
    var isOpen = body && body.classList.contains('open');

    ['Girls', 'Boys'].forEach(function(g) {
      var b = document.getElementById('bw' + g + 'Body');
      var t = document.getElementById('bw' + g + 'Tab');
      var a = document.getElementById('bw' + g + 'Arr');
      if (b) b.classList.remove('open');
      if (t) t.classList.remove('open');
      if (a) a.textContent = '↓';
    });

    if (!isOpen && body) {
      body.classList.add('open');
      if (tab) tab.classList.add('open');
      if (arr) arr.textContent = '↑';
    }
  };

  /* ── UGC TICKER: duplicate cards for seamless loop ── */
  var ugcTrack = document.getElementById('bwUgcTrack');
  var ugcDots  = document.getElementById('bwUgcDots');
  if (ugcTrack) {
    var ugcCards = ugcTrack.querySelectorAll('.bw-uc');
    if (ugcCards.length >= 1) {
      ugcCards.forEach(function(card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        ugcTrack.appendChild(clone);
      });
      var duration = Math.max(12, ugcCards.length * 6);
      ugcTrack.style.animationDuration = duration + 's';
    }
    if (ugcDots) ugcDots.style.display = 'none';
  }

  /* ── SHOP BY FEELING active state ── */
  document.querySelectorAll('.bw-feel-pill').forEach(function (p) {
    p.addEventListener('click', function () {
      document.querySelectorAll('.bw-feel-pill').forEach(function (x) { x.classList.remove('active'); });
      p.classList.add('active');
    });
  });

})();